export const HOVER_CURSOR_GAP = 20;
export function positionHoverCard(x: number, y: number, cardWidth: number, cardHeight: number, viewportWidth: number, viewportHeight: number) {
  const edge = 12;
  const width = Math.max(1, Math.min(cardWidth, viewportWidth - edge * 2));
  const height = Math.max(1, Math.min(cardHeight, viewportHeight - edge * 2));
  const clamp = (value: number, maximum: number) => Math.max(edge, Math.min(value, maximum));
  const right = viewportWidth - edge - x - HOVER_CURSOR_GAP;
  const left = x - HOVER_CURSOR_GAP - edge;
  const below = viewportHeight - edge - y - HOVER_CURSOR_GAP;
  const above = y - HOVER_CURSOR_GAP - edge;
  const top = clamp(y + HOVER_CURSOR_GAP, viewportHeight - height - edge);
  if (right >= width) return { left: x + HOVER_CURSOR_GAP, top, width, maxHeight: height };
  if (left >= width) return { left: x - width - HOVER_CURSOR_GAP, top, width, maxHeight: height };
  const centeredLeft = clamp(x - width / 2, viewportWidth - width - edge);
  if (below >= height) return { left: centeredLeft, top: y + HOVER_CURSOR_GAP, width, maxHeight: height };
  if (above >= height) return { left: centeredLeft, top: y - height - HOVER_CURSOR_GAP, width, maxHeight: height };
  // A short viewport may require a smaller preview, rather than covering the
  // pointer. The full result remains available by selecting the map area.
  if (Math.max(above, below) >= 40) {
    const maxHeight = Math.min(height, Math.max(above, below));
    return { left: centeredLeft, top: below >= above ? y + HOVER_CURSOR_GAP : y - maxHeight - HOVER_CURSOR_GAP, width, maxHeight };
  }
  const narrowWidth = Math.max(1, Math.min(width, Math.max(left, right)));
  return { left: right >= left ? x + HOVER_CURSOR_GAP : x - narrowWidth - HOVER_CURSOR_GAP, top, width: narrowWidth, maxHeight: height };
}
